// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

declare var require: any;

const packageJson = require('../../../../package.json');

export const environment = {
    appName: 'Longevity',
    offlineMode: false,
    envName: 'DEV',
    production: false,
    test: false,
    LgvApiBaseUrl: 'https://development-api.realfinity.io',     // DEV
    useNewAuth0Config: true,
    useMockData: false,
    LocalStorageKeys: {
        AuthType: 'LgvAuthType',
        RealFinityKey: 'RealFinity',
        HomeDashboardKey: 'HomeDashboard'
    },
    Auth0Config: {
        domain: "realfinity.us.auth0.com",
        clientID: "BvhrSoQuh5Rv93bHfddP9JKlxoD5u7Qg",
        audience: "Longevity_API"
    },
    PasswordAuth0Config: {
        domain: "realfinity.us.auth0.com",
        clientID: "4FgvvFCe7QMoOl4d6G5PBzHEqyHNOocD",
        audience: "Longevity_API"
    },
    SecureClientConfig: {
        name: 'HomeDashboard',
        domain: "homedashboard.us.auth0.com",
        clientID: "ic5p9ey5e2WPIhEp4JbES3ZYuwXEdqyv",
        audience: "Longevity_API"
    },
    versions: {
        app: packageJson.version,
        angular: packageJson.dependencies['@angular/core'],
        ngrx: packageJson.dependencies['@ngrx/store'],
        material: packageJson.dependencies['@angular/material'],
        bootstrap: packageJson.dependencies.bootstrap,
        rxjs: packageJson.dependencies.rxjs,
        ngxtranslate: packageJson.dependencies['@ngx-translate/core'],
        fontAwesome: packageJson.dependencies['@fortawesome/fontawesome-free'],
        angularCli: packageJson.devDependencies['@angular/cli'],
        typescript: packageJson.devDependencies['typescript'],
        cypress: packageJson.devDependencies['cypress']
    },
    jsonConfigs: {
        formly: {
            lendingPadLoanApp: '/assets/json/formly-configs/lending-loan-app.json',
            meridianLinkLoanApp: '/assets/json/formly-configs/meridian-loan-app.json',
            shortApplication: '/assets/json/formly-configs/short-application.json'
        },
        loanAppTermsAndConditions: '/assets/json/loan-app-terms.json'
    },
    scenarioId: '8AB12F98-B31E-EF11-96F5-6045BD0A165F',
    strapiServer: 'https://strapi.realfinity.io',
    POSTHOG_KEY: 'phc_jj8VfWZTuRTsVpbuoPGrONJoit98Z7qNvybG8iJ9Xed',
    POSTHOG_HOST: 'https://us.i.posthog.com'
};
